import juJurisdictionDelete from './jurisdiction-delete-action'
import juJurisdictionGenerate from './jurisdiction-generate'
import CustomerEdit from './CustomerEdit'

export default [ juJurisdictionDelete, juJurisdictionGenerate, CustomerEdit ]